export const config = {
  slotServiceUrl: process.env.REACT_APP_SLOTSERVICE
};